import { render, staticRenderFns } from "./searchKlnt.vue?vue&type=template&id=4ba3f6c4"
import script from "./searchKlnt.vue?vue&type=script&lang=js"
export * from "./searchKlnt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports